module.exports = __webpack_public_path__ + "media/components/brandings/svgs/email/branding-email-logo-78c6e0e1bdb3ec36c3af42614f778fd0.svg";